//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import get from 'lodash/get'
import hasArticles from '~/mixins/hasArticles'

export default {
  mixins: [hasArticles],

  async fetch({ store, error, query }) {
    try {
      await store.dispatch('articles/maybeFetch', query)

      if (!store.getters['articles/get'](query).length) {
        error({ statusCode: 404, message: 'Halaman tidak ditemukan.' })
      }
    } catch (e) {
      if (get(e, 'response.status') === 404) {
        error({ statusCode: 404, message: 'Halaman tidak ditemukan.' })
      } else {
        throw e
      }
    }
  },

  computed: {
    meta() {
      return get(this.getArticlesResult(this.$route.query), 'meta')
    },
  },

  watch: {
    '$route.query'() {
      this.$store.dispatch('articles/maybeFetch', this.$route.query)
    },
  },

  head() {
    return {
      title: 'Indeks artikel terbaru charm girls talk',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Kumpulan indeks artikel terbaru Charm Girl’s Talk menyajikan informasi seputar menstruasi dan dunia cewek dengan cara fun!',
        },
      ],
    }
  },
}
